import React from 'react';

import { Grid } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ChevronRight';
import styled from 'styled-components';

import { ITee } from '../../../../../../store/admin/courses/store';

interface IProps {
  onSelect: any;
  flightId: number;
  tee: ITee;
}

const SelectedTee = ({ onSelect, tee }: IProps) => {
  const edit = () => {
    onSelect({ value: tee });
  };

  return (
    <SelectedTeeStyled onClick={edit} className="grid" container={true} spacing={2}>
      <Grid className="grid-item" item={true} xs={5}>
        <span className="tee-markers">{tee.name.toUpperCase()}</span>
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        <span className="grey-square">{tee.par}</span>
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        <span className="grey-square">{tee.slope}</span>
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        <span className="grey-square">{tee.rating}</span>
      </Grid>

      <Grid className="grid-item" item={true} xs={1}>
        <ArrowDownwardIcon fontSize="inherit" />
      </Grid>
    </SelectedTeeStyled>
  );
};

export { SelectedTee };

const SelectedTeeStyled = styled(Grid)`
  .grid-item {
    margin-bottom: 0;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 0 !important;

    .tee-markers {
      text-transform: uppercase;
    }
    .grey-square {
      background-color: var(--greydd);
      padding: calc(var(--apx) * 10) calc(var(--apx) * 15);
      border-radius: calc(var(--px) * 8);
    }
  }
`;
